import DataTable from './Table';
import Column from './components/Column';
DataTable.Column = Column;
export default DataTable;